export default "__VITE_ASSET__Io0wFJJq__"